import { render } from "./CustomizationGroupSelectorCard.vue?vue&type=template&id=338ba103&scoped=true"
import script from "./CustomizationGroupSelectorCard.vue?vue&type=script&lang=js"
export * from "./CustomizationGroupSelectorCard.vue?vue&type=script&lang=js"

import "./CustomizationGroupSelectorCard.vue?vue&type=style&index=0&id=338ba103&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338ba103"]])

export default __exports__